import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import CanonicalIssuesRow from '../CanonicalIssuesRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class CanonicalIssuesTable extends React.Component {
  static propTypes = {
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        canonicalCategory: PropTypes.shape({
          countTypesCanonicalIssues: PropTypes.arrayOf(
            PropTypes.shape({
              count: PropTypes.number,
              severity: PropTypes.number,
              type: PropTypes.string
            })
          ),
          canonicalIssues: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired
  }

  render () {
    const toggles = get(this.props.project, 'crawls.edges[0].node.countTypesCanonicalIssues', [])
      .map(v => ({ identifier: v.type, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('typeFilters', toggles)}
            checkedItems={this.props.filters.typeFilters}
            groups={toggles}
            name='typeFilters'
            label={<Translate content='crawler_canonical_issue' />}
          />
          <FilterString
            onChange={this.props.onGraphQLInputChange('canonicalUrl')}
            value={this.props.filters.canonicalUrl}
            name='canonicalUrl'
            label={<Translate content='crawler_canonical_url' />}
          />
          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='canonicalCategory' section='canonicalIssues'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_canonical_issue' size='3' />
            <Translate content='crawler_canonical_url' size='4' />
            <Translate content='crawler_source_page_url' size='5' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={CanonicalIssuesRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(CanonicalIssuesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment CanonicalIssuesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        canonicalUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        typeFilters: {type: "[String]", defaultValue: []}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              countTypesCanonicalIssues(canonicalUrl: $canonicalUrl, sourceUrl: $sourceUrl) {
                type
                severity
                count
              }
              canonicalIssues(offset: $offset, limit: $limit, sourceUrl: $sourceUrl, canonicalUrl: $canonicalUrl, typeFilters: $typeFilters) {
                count
                edges {
                  node {
                    ...CanonicalIssuesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query CanonicalIssuesTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $typeFilters: [String],
        $sourceUrl: TextFilters,
        $canonicalUrl: TextFilters) {,
        project (host: $host) {
          ...CanonicalIssuesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            typeFilters: $typeFilters,
            canonicalUrl: $canonicalUrl,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
